import validate from "/vercel/path0/node_modules/.pnpm/nuxt@3.17.6_@parcel+watcher@2.5.1_@types+node@24.0.10_@vercel+blob@1.1.1_@vue+compiler-sfc@3._66ubvd4ctn4l2rstl4hjlmicsq/node_modules/nuxt/dist/pages/runtime/validate.js";
import manifest_45route_45rule from "/vercel/path0/node_modules/.pnpm/nuxt@3.17.6_@parcel+watcher@2.5.1_@types+node@24.0.10_@vercel+blob@1.1.1_@vue+compiler-sfc@3._66ubvd4ctn4l2rstl4hjlmicsq/node_modules/nuxt/dist/app/middleware/manifest-route-rule.js";
export const globalMiddleware = [
  validate,
  manifest_45route_45rule
]
export const namedMiddleware = {
  auth: () => import("/vercel/path0/middleware/auth.ts")
}